import Loading from 'app/icons/Custom/Loading/Loading';
import React from 'react';
import { SpinnerLoadingContainer } from './SpinnerLoading.styles';

interface SpinnerLoadingProps {
  width?: number;
  color?: string;
}

const SpinnerLoading = ({ width = 20, color = 'var(--gray-light-400)' }: SpinnerLoadingProps): JSX.Element => (
  <SpinnerLoadingContainer>
    <Loading
      width={width}
      color={color}
    />
  </SpinnerLoadingContainer>
);

export default SpinnerLoading;
